import React from 'react'

export default class ConfirmAddressButton extends React.Component {

    handleClick = (event) => {
        event.preventDefault();

        if (this.props.disabled) { return; }

        this.props.onClick();
    };

    render() {
        const { text, disabled } = this.props;
        return (
            <a
               id="confirm-address-button"
               className={`btn btn-primary btn-block ${disabled ? 'disabled' : 'btn-primary'}` }
               href="#"
               onClick={this.handleClick}>{ text }</a>
        )
    }
}